import React from 'react';

export const Spacer = () => {
  return <div style={{ width: '100%', height: 50 }} />;
};
